/**
 * Значение для CSS `background-image` / custom property: без кавычек `url(data:...)` обрывается на запятой в `charset=utf-8,`.
 * Внешние одинарные кавычки — чтобы в HTML не конфликтовать с кавычками атрибута `style`.
 */
export function cssUrlValue(href: string): string {
  return `url('${href.replace(/\\/g, '\\\\').replace(/'/g, "\\'")}')`;
}
